import React, { useState } from 'react';
import SignIn from './SignIn';
import SignUp from './SignUp';

const Auth = () => {
    const [currentForm, setCurrentForm] = useState('signin');

    return (
        <div>
            <button onClick={() => setCurrentForm('signin')}>Sign In</button>
            <button onClick={() => setCurrentForm('signup')}>Sign Up</button>
            {currentForm === 'signin' ? <SignIn /> : <SignUp />}
        </div>
    );
};

export default Auth;

